import AxiosService from '../AxiosService';

const MyOrdersPost = async (
  diasPedido: number,
  category?: string,
  brand?: string,
  search?: string,
  sort?: string,
): Promise<IResponseMyOrders> => {
  const instance = AxiosService.createAuthAxiosInstance();
  const response = await instance.get('/v1/client/my-orders', {
      params: {
        dias_pedido: diasPedido
      }
  });
  return response.data;
};

const MyUpdatedOrdersPost = async (
  diasPedido: number,
  type?: string,
  status?: string
): Promise<IResponseMyOrders> => {
  const instance = AxiosService.createAuthAxiosInstance();
  const response = await instance.get('/v1/client/my-updated-orders', {
      params: {
        dias_pedido: diasPedido,
        type,
        status
      }
  });
  return response.data;
};

const MyStatusOrdersPost = async (): Promise<Array<any>> => {
  const instance = AxiosService.createAuthAxiosInstance();
  const response = await instance.get('/v1/client/my-status-orders');
  return response.data;
};

const downloadNF = async chaveNF => {
  const instance = AxiosService.createAuthAxiosInstance();
  const nfkey = Array.isArray(chaveNF) ? chaveNF : [chaveNF];
  const response = await instance.post(
    '/v1/client/my-order-nf',
    {
      nfkey,
    },
    {
      responseType: 'blob',
    },
  );

  const base64data = await new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(response.data);
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
  });

  return base64data;
};
const downloadBoletos = async chaveNF => {
  const instance = AxiosService.createAuthAxiosInstance();
  const nfkey = Array.isArray(chaveNF) ? chaveNF : [chaveNF];

  const response = await instance.post(
    `/v1/client/my-order-boleto`,
    {
      nfkey,
    },
    {
      responseType: 'blob',
    },
  );

  const base64data = await new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(response.data);
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
  });

  return base64data;
};

const checkScheculedOrders = async (clientCode: string) => {
  const instance = AxiosService.createProductsAxiosInstance();
  const response = await instance.get('/lastOrder', {
    headers: {
      'client-code': clientCode,
    },
  });
  return response.data;
};

const CancelOrder = async (clientCode: string, orderNumber: string, reason: string) => {
  const instance = AxiosService.createProductsAxiosInstance();

  try {
    const response = await instance.post('/cancelOrder', {}, {
      headers: {
        'client-code': clientCode,
        'order-number': orderNumber,
        'reason': reason,
      },
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};

const OrderDeliveryDate = async (clientCode: string, orderNumber: string) => {
  const instance = AxiosService.createProductsAxiosInstance();
  try {
    const response = await instance.post('/client/orderDeliveryDate', {}, {
      headers: {
        'client-code': clientCode,
        'order-number': orderNumber,
      },
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};

const PendingPaymentOrders = async (data: any) => {
  const instance = AxiosService.createProductsAxiosInstance();
  const response = await instance.post('/iopay/pix/recent', {...data});

  return response.data;
};

const PendingOrders = async (data: any) => {
  const instance = AxiosService.createProductsAxiosInstance();
  const response = await instance.post('/iopay/order/pending', {...data});

  return response.data;
};


export default {
  MyOrdersPost,
  checkScheculedOrders,
  downloadNF,
  downloadBoletos,
  MyUpdatedOrdersPost,
  MyStatusOrdersPost,
  CancelOrder,
  OrderDeliveryDate,
  PendingPaymentOrders,
  PendingOrders,
};
